<template>
  <div class="">
    <iframe
      id="forms-church-creation-iframe"
      width="100%"
      scrolling="false"
      :src="sourceUrl"
      frameborder="0"
      ref="myIframe"
      @load="iframeLoaded"
    ></iframe>
  </div>
</template>

<script>
  import iframeResizer from "iframe-resizer"

  export default {
    name: '',
    data () {
      return {
      }
    },
    created () {
      console.log("Data for iframe", this.data)
    },
    computed: {
      resizeOptions() {
        return {
          log: false,
          scrolling: false,
          heightCalculationMethod: "taggedElement",
        }
      },
      sourceUrl(){
        let url = this.data.params.data.url
        return url
      }
    },
    methods: {
      resize() {
        const iframes = iframeResizer.iframeResizer(this.resizeOptions, this.$refs.myIframe);
        console.log(this.$refs)
      },
      iframeLoaded(e) {
        this.resize()
      },
    },
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
</style>
